// Add tooltip functionality for product nutritional information
$(document).ready(function() {
  // Create tooltip container that will be reused
  $('body').append('<div id="product-tooltip" class="product-tooltip"></div>');
  const tooltip = $('#product-tooltip');
  let currentTooltipElement = null;
  
  // Determine if we're on mobile
  const isMobile = window.matchMedia("(max-width: 768px)").matches;
  
  // Calculate optimal position for the tooltip
  function positionTooltip(target) {
    const targetRect = target[0].getBoundingClientRect();
    const scrollTop = $(window).scrollTop();
    const tooltipWidth = tooltip.outerWidth();
    const tooltipHeight = tooltip.outerHeight();
    const windowWidth = $(window).width();
    
    // Determine horizontal position
    let left = targetRect.left + (targetRect.width - tooltipWidth) / 2;
    // Make sure tooltip doesn't go off-screen horizontally
    left = Math.max(10, Math.min(left, windowWidth - tooltipWidth - 10));
    
    // Determine vertical position
    let top;
    if (isMobile) {
      // On mobile, position below the element
      top = targetRect.bottom + scrollTop + 10;
    } else {
      // On desktop, try to position above the element if there's room
      if (targetRect.top > tooltipHeight + 20) {
        top = targetRect.top + scrollTop - tooltipHeight - 10;
      } else {
        // Otherwise position below
        top = targetRect.bottom + scrollTop + 10;
      }
    }
    
    tooltip.css({ top: top + 'px', left: left + 'px' });
  }
  
  // Show tooltip with product info
  function showTooltip(button) {
    // Get the parent bundle_pick element that contains the data
    const bundlePick = $(button).closest('.bundle_pick');
    
    // Get product title from the element
    const productTitle = bundlePick.find('.cart__item-name').text().trim();
    
    // Get product description
    let productDescription = bundlePick.data('product-description');
    
    if (!productDescription || productDescription === "") {
      // If no description, show a message
      tooltip.html(`
        <div class="tooltip-header">${productTitle}</div>
        <div class="tooltip-content">No detailed information available for this product.</div>
      `);
    } else {
      // Remove images from description to save space
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = productDescription;
      
      // Remove all img tags
      const imgTags = tempDiv.querySelectorAll('img');
      imgTags.forEach(img => img.remove());
      
      // Get cleaned HTML
      productDescription = tempDiv.innerHTML;
      
      // Set tooltip content
      tooltip.html(`
        <div class="tooltip-header">${productTitle}</div>
        <div class="tooltip-content">${productDescription}</div>
      `);
    }
    
    // Display tooltip
    tooltip.addClass('active');
    positionTooltip($(button));
    
    // Remember current element
    currentTooltipElement = button;
  }
  
  // Hide tooltip
  function hideTooltip() {
    tooltip.removeClass('active');
    currentTooltipElement = null;
  }
  
  // Click event for the meal info button
  $(document).on('click', '.meal-info-button', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // If this button's tooltip is already open, close it
    if (currentTooltipElement === this) {
      hideTooltip();
    } else {
      // If another tooltip is open, close it first
      if (currentTooltipElement) {
        hideTooltip();
      }
      // Show the new tooltip
      showTooltip(this);
    }
  });
  
  // Close tooltip when clicking outside
  $(document).on('click', function(e) {
    if (tooltip.hasClass('active') && !$(e.target).closest('.meal-info-button, #product-tooltip').length) {
      hideTooltip();
    }
  });
  
  // Close tooltip when pressing escape key
  $(document).on('keydown', function(e) {
    if (e.key === "Escape" && tooltip.hasClass('active')) {
      hideTooltip();
    }
  });
  
  // Reposition tooltip on window resize
  $(window).on('resize', function() {
    if (tooltip.hasClass('active') && currentTooltipElement) {
      positionTooltip($(currentTooltipElement));
    }
  });
  
  // Reposition tooltip on scroll
  $(window).on('scroll', function() {
    if (tooltip.hasClass('active') && currentTooltipElement) {
      positionTooltip($(currentTooltipElement));
    }
  });
});